export const dialects = [
  'zh_TW',
  'nl_NL',
  'en_AU',
  'en_CA',
  'en_ZA',
  'en_GB',
  'en_US',
  'fr_CA',
  'fr_FR',
  'de_AT',
  'de_DE',
  'de_CH',
  'es_AR',
  'es_LA',
  'es_MX',
  'es_ES'
];
